import Backbone from 'backbone';
import _ from 'underscore';
import ko from 'knockout';
import $ from 'jquery';
import ViewModel from '@bingads-webui-campaign-legacy/auto-targets/viewmodel/create/selectedTargets';
import template from '@bingads-webui-campaign-legacy/auto-targets/template/create/selectedTargets.pug';
import TargetPreviewView from '@bingads-webui-campaign-legacy/auto-targets/view/create/targetPreview';
import { isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import config from '@bingads-webui-component-legacy/config/index';

import { DoubleListA11yHacker } from '@bingads-webui-campaign-legacy/auto-targets/view/double-list-a11y-hacker';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.viewmodel = new ViewModel({
      defaultBid: this.options.defaultBid,
      activityLogger: this.options.activityLogger,
      isNegativeAutoTarget: this.options.isNegativeAutoTarget,
    });
    this.savedTargets = {};
    this.viewmodel.values.subscribe((values) => {
      this.trigger('update:values', values);
    });
    this.viewmodel.items.subscribe((items) => {
      this.trigger('update:items', items);

      // wait for dom updated
      _.defer(() => {
        this.doubleListA11yHacker.refresh();
      });
    });

    // Validate if show no target selected error message
    this.validate();

    this.doubleListA11yHacker = new DoubleListA11yHacker({
      rootSelector: '.dlb-selected-container ul[data-bind="foreach: items"]',
      listViewSelector: '.dlb-selected-container ul[data-bind="foreach: items"]',
      itemSelector: 'li',
      interactableElementSelector: 'input[type=text], a.arrow-button, a.clickable',
      listAriaLabel: i18n.get('DSA_AutoTargets_Select_Title'),
    });

    this.isNegativeAutoTarget = this.options.isNegativeAutoTarget;
    this.popupId = this.options.isNegativeAutoTarget ? 'pop_BA_CampaignCreate_Targets_NegativeTargets' : 'pop_BA_CampaignCreate_Keywords_SelectedTargets';
  }
  get events() {
    return {
      'click .specificpage': 'renderPreview',
      'click .exacturls': 'renderPreview',
    };
  }
  render() {
    this.$el.html(template({i18n, accountCurrencyCode: config.get('AccountCurrencyCode'), isForVNext: this.options.isForVNext, isNegativeAutoTarget: this.isNegativeAutoTarget, popupId: this.popupId }));
    ko.applyBindings(this.viewmodel, this.el);
    return this;
  }
  renderPreview(e) {
    if (this.targetPreviewView) {
      this.targetPreviewView.close();
    }

    const targetClass = 'popover-operand';

    $(e.currentTarget).find(`.${targetClass}`).remove();

    $(e.currentTarget).find('.preview-operand').append(`<span class="${targetClass}" />`);

    this.targetPreviewView = new TargetPreviewView({target: $(e.currentTarget).find(`.${targetClass}`), conditions: $(e.currentTarget).data('conditions')}).render();
  }
  getChanges() {
    const changes = [];

    _.each(this.viewmodel.items(), (item) => {
      const targetSaved = this.savedTargets[item.key];

      if (!targetSaved || targetSaved.Bid !== item.Bid()) {//eslint-disable-line
        const targetToSave = _.pick(item.toObject(), 'Bid', 'Criterion');

        if (targetSaved) {
          targetToSave.Criterion.WebPage.Parameter.Conditions = [];
          targetToSave.Id = targetSaved.Id;
        }
        changes.push(targetToSave);
      }
    });

    const keysOfDeletedTargets = _.difference(_.keys(this.savedTargets), _.pluck(this.viewmodel.items(), 'key'));

    _.each(keysOfDeletedTargets, (key) => {
      const targetSaved = this.savedTargets[key];

      targetSaved.Status = 'Deleted';
      targetSaved.Criterion.WebPage.Parameter.Conditions = [];
      changes.push(targetSaved);
    });
    return changes;
  }
  updateViewModels(targets) {
    _.each(targets, (target) => {
      const key = _.findKey(this.savedTargets, (value) => {
        return value.Id === target.Id;
      }) || this.getKey(target);

      const targetInVm = this.viewmodel.keyToItemMapping[key];

      if (targetInVm) {
        targetInVm.errors.clear(isCampaignApiError);
      }

      if (target.errors) {
        if (targetInVm) {
          targetInVm.errors.add(target.errors);
          targetInVm.hasErrors = true;
        }
      } else {
        const previouslySavedTarget = this.savedTargets[key];

        if (previouslySavedTarget && previouslySavedTarget.Status === 'Deleted') {
          delete this.savedTargets[key];
        } else {
          this.savedTargets[key] = target;
        }
      }
    });
    this.viewmodel.hasChanges = false;
  }
  validate() {
    if (this.viewmodel.items().length === 0) {
      this.viewmodel.errors([i18n.get('DSA_Dynamic_AutoTargets_Error_No_Target')]);
      if (this.options.activityLogger) {
        this.options.activityLogger.signal('no target selected', 'ad target selection');
      }
      return false;
    } else {
      this.viewmodel.errors([]);
    }

    return _.every(this.viewmodel.items(), (item) => item.validate() && !item.hasErrors);
  }
  getKey(target) {
    return JSON.stringify(ko.unwrap(target.Criterion).WebPage.Parameter.Conditions);
  }

  setErrors(errors) {
    const viewModelItems = this.viewmodel.items();
    const errorItems = [];
    const needRemovedItems = [];

    for (let i = 0; i < viewModelItems.length; i++) {
      if (errors[i]) {
        viewModelItems[i].errors([errors[i]]);
        errorItems.push(viewModelItems[i]);
      } else {
        needRemovedItems.push(viewModelItems[i]);
      }
    }

    // Keep error items in selected panel
    this.viewmodel.update(errorItems, needRemovedItems);
  }
}
